module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "nav-menu"
    }
  }, [_c('div', {
    ref: "searchbar",
    attrs: {
      "id": "search-bar"
    }
  }, [_c('search-input', {
    attrs: {
      "placeholder": "Search by username..."
    },
    on: {
      "search": _vm.getUsers,
      "focus": _vm.fullNavMenu
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "cancel-button"
    },
    on: {
      "click": _vm.openNavMenu
    }
  }, [_vm._v("Cancel")])], 1), _vm._v(" "), _c('div', {
    ref: "userlist",
    attrs: {
      "id": "user-list"
    },
    on: {
      "scroll": _vm.highlightSearchbar
    }
  }, _vm._l((_vm.users), function(user) {
    return _c('a', {
      staticClass: "user-item animated",
      attrs: {
        "transition": "fade",
        "stagger": "100"
      },
      on: {
        "click": function($event) {
          return _vm.handleClick(user.login)
        }
      }
    }, [_c('avatar', {
      staticClass: "user-avatar",
      attrs: {
        "src": ("https://avatars.githubusercontent.com/u/" + (user.id.split('-')[1]))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user-info"
    }, [_c('div', {
      staticClass: "fullname"
    }, [_vm._v(_vm._s(user.fullname || user.login))]), _vm._v(" "), _c('div', {
      staticClass: "username"
    }, [_vm._v(_vm._s(user.login || user.fullname))])])], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4da3bb2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavMenu.vue
// module id = 458
// module chunks = 2